import { createSnapshotTracker, resetHistory } from '@/utils/History'

export const DETAIL_HISTORY = 'detail'

export default {
    beforeDestroy() {
        this.stopDetailHistory()
    },
    methods: {
        startDetailHistory(read, write) {
            const vm = this
            vm.stopDetailHistory()
            vm._detailTracker = createSnapshotTracker({ context: DETAIL_HISTORY, read, write })
        },
        commitDetailHistory(label, key = null) {
            if (this._detailTracker) this._detailTracker.commit(label, key)
        },
        syncDetailHistory() {
            if (this._detailTracker) this._detailTracker.sync()
        },
        stopDetailHistory() {
            const vm = this
            if (vm._detailTracker) vm._detailTracker.destroy()
            vm._detailTracker = null
            resetHistory(DETAIL_HISTORY)
        },
    },
}
